import { useTranslation } from 'react-i18next';
import { Body2 } from '@/components/@IntranetLibrary/Typography';
import ExternalLoanBody from '@/components/Approval/@components/ExternalLoan';
import InfoSection, {
  APPROVAL_SECTION_GAP,
} from '@/components/Approval/@components/InfoSection';
import { parseExternalLoanData } from '@/utils/approval/externalLoan';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 217 외담대 발행 — 상신 때 저장한 발행내역으로 다시 그림. SAP 재조회 안 함 */
const ExternalLoanSlot = ({ data }: ContentExtraProps) => {
  const { t, i18n } = useTranslation();
  const saved = parseExternalLoanData(data.attributes);
  if (!saved) return null;
  return (
    <ContentSlotRoot
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: `${APPROVAL_SECTION_GAP}px`,
      }}
    >
      <InfoSection title={t('구매카드 발급일')}>
        <Body2 sx={{ color: 'var(--dk-text, #131313)' }}>
          {saved.issueDate}
        </Body2>
      </InfoSection>
      {saved.items.length > 0 && (
        <ExternalLoanBody
          issueDate={saved.issueDate}
          items={saved.items}
          t={t}
          lang={i18n.language}
        />
      )}
    </ContentSlotRoot>
  );
};

export default ExternalLoanSlot;
